import { render, staticRenderFns } from "./addFormBatch.vue?vue&type=template&id=a8a0f4f4&scoped=true&"
import script from "./addFormBatch.vue?vue&type=script&lang=js&"
export * from "./addFormBatch.vue?vue&type=script&lang=js&"
import style0 from "./addFormBatch.vue?vue&type=style&index=0&id=a8a0f4f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a0f4f4",
  null
  
)

export default component.exports